import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import SEO from "../seo/SEO";

export const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-5">
      <SEO title="Admin sign in — Karen Boley Counselling" noindex />
      <form data-testid="login-form" onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl border border-cream-2 shadow-xl p-8">
        <h1 className="font-serif text-3xl text-ink">Admin sign in</h1>
        <p className="text-sm text-ink-muted mt-1">Karen Boley Counselling</p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-wide text-ink-muted mb-1">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-lg border border-cream-2 px-3 py-2.5 text-ink outline-none focus:border-sage" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wide text-ink-muted mb-1">Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-lg border border-cream-2 px-3 py-2.5 text-ink outline-none focus:border-sage" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-sage text-white py-3 font-semibold hover:bg-sage-dark transition-colors disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
          <div className="text-center pt-1">
            <Link
              to="/admin/forgot-password"
              data-testid="login-forgot-link"
              className="text-sm font-medium text-sage-dark hover:text-sage transition-colors"
            >
              Forgot your password?
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
